import { toast } from "react-toastify";
import { fetchQuery } from "../../utils/commonComponent/fetched";

export const handleWithdrawApproval = async (certificateIds) => {
  const isConfirmed = window.confirm("Are you sure you want to withdraw the approval?");
  if (!isConfirmed) return;

  try {
    const normalizedIds = Array.isArray(certificateIds) ? certificateIds : [certificateIds];
    
    if (!normalizedIds.length) {
      toast.error("No certificate found!");
      return;
    }

    const idList = normalizedIds.join(",");

    // Step 1: Fetch observation sheet IDs
    const obsRows = await fetchQuery(`SELECT id, certificateId FROM observationSheet WHERE certificateId IN (${idList}) AND status != -1`);

    if (!obsRows?.length) {
      toast.error("No observation sheets found!");
      return;
    }

    const obsIds = obsRows.map((row) => row.id).join(",");

    // Step 2: Update observation sheets requestApproval = 0 using fetched IDs
    await fetchQuery(`UPDATE observationSheet SET requestApproval = 0 WHERE id IN (${obsIds})`);

    // Step 3: Nullify certificate approval fields
    await fetchQuery(`UPDATE certificate SET preparedBy = NULL, preparedDate = NULL, reviewedBy = NULL, reviewedDate = NULL, authorizedBy = NULL, authorizedDate = NULL, rejectedBy = NULL WHERE id IN (${idList})`
    );

    toast.success("Approval withdrawn successfully!");
    setTimeout(() => window.location.reload(), 500);
  } catch (error) {
    console.error("Error withdrawing approval:", error);
  }
};